import { render, staticRenderFns } from "./ViewKnowledgeArticle.vue?vue&type=template&id=3c759a68"
import script from "./ViewKnowledgeArticle.vue?vue&type=script&lang=js"
export * from "./ViewKnowledgeArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports